import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import Vuelidate from 'vuelidate'
import VueCarousel from '@chenfengyuan/vue-carousel'

import 'bootstrap'

Vue.use(Vuelidate)
Vue.use(VueCarousel)

Vue.config.productionTip = false

axios.defaults.headers.get['Accept'] = 'application/json'
axios.defaults.headers.post['Content-type'] = 'application/json'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
